/**
 *  Default Google Map init
 */

var Cromology = Cromology || {};
Cromology.maps = (function ($, self) {
  var isInit = false,
    defer = $.Deferred();
  function init() {
    if (isInit) return true;
    $.getScript('https://maps.googleapis.com/maps/api/js?libraries=places&callback=CromologyMapsInit&key=' + Zolpan.vars.google_api_key);
    isInit = true;
  }
  function onLoad(callback) {
    init();
    defer.done(callback);
  }
  function loading() {
    defer.resolve();
  }
  return $.extend(self, {
    init: init,
    loading: loading,
    onLoad: onLoad,
  });
})(jQuery, {});
CromologyMapsInit = Cromology.maps.loading;

(function ($) {
  'use strict';

  $(window).ready(init);

  // Constants
  var WIDGET_SEL = '[data-map]';
  var WIDGET_MAP_SEL = '[data-map-canvas]';
  var WIDGET_SEARCH_SEL = '[data-map-search]';
  var WIDGET_BRANDS_SEL = '[data-map-brands]';
  var WIDGET_RESET_SEL = '[data-map-reset]';
  var WIDGET_GEOLOCATE = '[data-map-geolocate]';
  var WIDGET_TOLLENS_SEL = '[data-map-tollens]';
  var WIDGET_ZOLPAN_SEL = '[data-map-zolpan]';
  var WIDGET_ROBBIALAC_SEL = '[data-map-robbialac]';
  var WIDGET_PLASDOX_SEL = '[data-map-plasdox]';
  var MOBILE_MAP_LEGEND_CONTAINER = '.Map-legend--mobile'
  var MOBILE_MAP_LEGEND_BTN = '.Map-legend--btn';
  var MOBILE_MAP_LEGEND_ITEMS = '.Map-legend-items';
  var MOBILE_MAP_INTRO = '.RichText.StoreLocator-centered';
  var MOBILE_MAP_INTRO_SHOW_MORE = '.StoreLocator-showMore';
  var MAP;
  var MAPSTYLE = [{
    "featureType": "administrative",
    "elementType": "labels.text.fill",
    "stylers": [{"color": "#444444"}]
  }, {"featureType": "landscape", "elementType": "all", "stylers": [{"color": "#f2f2f2"}]}, {
    "featureType": "poi",
    "elementType": "all",
    "stylers": [{"visibility": "off"}]
  }, {"featureType": "poi", "elementType": "labels.text", "stylers": [{"visibility": "off"}]}, {
    "featureType": "road",
    "elementType": "all",
    "stylers": [{"saturation": -100}, {"lightness": 45}]
  }, {
    "featureType": "road.highway",
    "elementType": "all",
    "stylers": [{"visibility": "simplified"}]
  }, {
    "featureType": "road.arterial",
    "elementType": "labels.icon",
    "stylers": [{"visibility": "off"}]
  }, {"featureType": "transit", "elementType": "all", "stylers": [{"visibility": "off"}]}, {
    "featureType": "water",
    "elementType": "all",
    "stylers": [{"color": "#dbdbdb"}, {"visibility": "on"}]
  }];

  var MARKERPATH = 'M.4-30c3.8 0 7 3 7 7 0 3.7-3 7-7 7-3.8 0-7-3.2-7-7 0-4 3-7 7-7M-1.4-1C-.7.3 1.4.3 2-1c0 0 8.4-12.3 10.3-16 2-4 2-8.2 0-12C9-35.8 1-38.4-5.7-35c-6.5 3.3-9 11.6-5.8 18 3 6.2 10 16 10 16';
  var ZOLPANMARKERPATH = 'M35.8701 0.0195312C38.71 0.0195954 41.0195 2.33 41.0195 5.16992V21.6602L41 35.8701C40.9999 38.7101 38.6896 41.0195 35.8496 41.0195H28.3096L20.5195 50.0098L11.6904 41.0098H5.15039C2.31039 41.0098 0 38.6896 0 35.8496V21.6396L0.0195312 5.15039C0.0295309 2.31049 2.33983 0.000169356 5.17969 0L35.8701 0.0195312ZM10.3301 6.83008L6.92969 11.0801L6 12.2402H7.49023L24.0801 12.25L6.57031 27.4297L6.32031 27.6396V33.1904H7.04004L34.3203 33.21H35.04V27.5303H16.6904L34.1104 12.3604L34.3604 12.1504V6.57031H10.8896L10.5498 6.55957L10.3301 6.83008Z';
  var TOLENSMARKERPATH = 'M2.045.045c-1.1 0-2 .9-2 2v20c0 1.1.9 2 2 2h4.58l5.42 5 5.33-5h4.67c1.1 0 2-.9 2-2v-20c0-1.1-.9-2-2-2h-20zm1.86 2.44h16.3v4h-5.82v15.128h-4.68V6.484h-5.8v-4z';
  var INFOWINDOW;
  var DISPLAY_TOOLTIP = true;
  var markersList= [];
  var searchMarker;
  var siteaccess, markers, mapIcon, markerPath, gmbMarkerPath, zolpanMarkerPath, tollensMarkerPath, zolpanTollensMarkerPath, zolpanMarkerPathIdependent, tollensMarkerPathIdependent, mainMarkerPath, mapZoom, mapOptions, mapCenter, cta, bounds, colors, isSearch, mapsLink;

  Translator.locale = $('html').attr('lang');
  /**
   * Init
   */
  function init() {
    var widget = $(WIDGET_SEL);
    if (widget.length === 0) {
      return;
    }
    Cromology.maps.onLoad(function(){
      setUpMap(widget);
      if (widget.find(WIDGET_SEARCH_SEL)) {
        initializeSearchBox();
      }
    });
  }

  // setup map options
  function setUpMap(widget) {  

    $(MOBILE_MAP_LEGEND_BTN).on("click", function(event) {
      event.stopPropagation();
      $(MOBILE_MAP_LEGEND_ITEMS).toggleClass('Map-legend-items--hidden')
      $(MOBILE_MAP_LEGEND_CONTAINER).toggleClass('Map-legend--expanded')
      if ($(MOBILE_MAP_LEGEND_ITEMS).hasClass('Map-legend-items--hidden')) {
        $(MOBILE_MAP_LEGEND_BTN).text('Voir la légende');
      } else {
        $(MOBILE_MAP_LEGEND_BTN).text('Fermer');
      }
    })

    $(MOBILE_MAP_INTRO_SHOW_MORE).on("click", function(event) {
      event.stopPropagation();
      if ($(MOBILE_MAP_INTRO).hasClass('StoreLocator-expanded')) {
        $(MOBILE_MAP_INTRO).removeClass('StoreLocator-expanded')
        $(MOBILE_MAP_INTRO_SHOW_MORE).text('Voir plus');
      } else {
        $(MOBILE_MAP_INTRO).addClass('StoreLocator-expanded')
        $(MOBILE_MAP_INTRO_SHOW_MORE).text('Voir moins');
      }
    })

    markers = widget.data('map');
    mapZoom = widget.data('map-zoom') ? widget.data('map-zoom') : 6;
    mapCenter = widget.data('map-center');
    isSearch = widget.data('map-is-search');
    mapsLink = widget.data('map-maps-link') ? widget.data('map-maps-link') : '';
    siteaccess = widget.data('map-siteaccess') ? widget.data('map-siteaccess') : '';

    cta = widget.data('map-tooltipcta');
    colors = widget.data('map-colors');
    mapIcon = widget.data('map-icon') || MARKERPATH;
    markers = $.map(markers, function (value) {
      return [value];
    });

    //color marker independant
    markerPath = {
      path: mapIcon,
      fillColor: colors.main,
      fillOpacity: 1,
      scale: 0.85,
      strokeWeight: 0
    };

    //color marker gmb
    gmbMarkerPath = {
      path: mapIcon,
      fillColor: colors.gmb,
      fillOpacity: 1,
      scale: 0.85,
      strokeWeight: 0
    };

    zolpanMarkerPath = {
      path: ZOLPANMARKERPATH,
      fillColor: colors.zolpan,
      fillOpacity: 1,
      scale: 0.52,
      strokeWeight: 0
    };

    tollensMarkerPath = {
      path: TOLENSMARKERPATH,
      fillColor: colors.tollens,
      fillOpacity: 1,
      scale: 0.85,
      strokeWeight: 0
    };

    zolpanTollensMarkerPath = {
      url: 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent('<svg width="25" height="25" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">' +
        '<g clip-path="url(#clip0_3_2)">' +
        '<path fill-rule="evenodd" clip-rule="evenodd" d="M45.49 21.66V35.87C45.48 38.71 43.17 41.02 40.33 41.02H32.79L25 50.01L16.17 41.01H9.63C6.79 41.01 4.48 38.69 4.48 35.85V21.64L45.48 21.67L45.49 21.66Z" fill="#247633"/>' +
        '<path fill-rule="evenodd" clip-rule="evenodd" d="M45.5 5.17V21.66L4.5 21.63V5.15C4.51 2.31 6.82 0 9.66 0L40.35 0.02C43.19 0.02 45.5 2.33 45.5 5.17Z" fill="#003A5D"/>' +
        '<path fill-rule="evenodd" clip-rule="evenodd" d="M45.5 5.17V21.66L4.5 21.63V5.15C4.51 2.31 6.82 0 9.66 0L40.35 0.02C43.19 0.02 45.5 2.33 45.5 5.17Z" fill="#003A5D"/>' +
        '<path d="M32.66 35.51H22.93L32.54 27.15L32.68 27.03V26.85V24.35V23.96H32.29H19.75H19.56L19.44 24.11L17.57 26.45L17.06 27.09H17.88H27.03L17.38 35.46L17.24 35.58V35.76V38.24V38.63H17.63H32.67L33.06 38.64V38.25V35.91V35.52H32.67L32.66 35.51Z" fill="white"/>' +
        '<path d="M31.56 1.97V5.39H27.33V19.01H22.78V5.39H18.56V1.97H31.56Z" fill="white"/>' +
        '</g>' +
        '<defs>' +
        '<clipPath id="clip0_3_2">' +
        '<rect width="50" height="50" fill="white"/>' +
        '</clipPath>' +
        '</defs>' +
        '</svg>'),
    };

    zolpanMarkerPathIdependent = {
      path: ZOLPANMARKERPATH,
      fillColor: colors.independant,
      fillOpacity: 1,
      scale: 0.52,
      strokeWeight: 0
    };

    tollensMarkerPathIdependent = {
      path: TOLENSMARKERPATH,
      fillColor: colors.independant,
      fillOpacity: 1,
      scale: 0.85,
      strokeWeight: 0
    };

    mainMarkerPath = "/assets/themes/tollens/images/location.svg"

    if(!mapCenter){
      mapOptions = {
        mapTypeControl: false,
        streetViewControl: false,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        styles: MAPSTYLE,
        maxZoom: 15,
        minZoom: 2,
        zoom: mapZoom
      };
    }else{
      mapOptions = {
        mapTypeControl: false,
        streetViewControl: false,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        styles: MAPSTYLE,
        maxZoom: 15,
        minZoom: 2,
        center: mapCenter,
        zoom: mapZoom
      };
    }

    bounds = new google.maps.LatLngBounds();
    INFOWINDOW = new google.maps.InfoWindow({content: ''});
    MAP = new google.maps.Map($(WIDGET_MAP_SEL)[0], mapOptions);
    DISPLAY_TOOLTIP = markers.length > 1 ? true : false;  // don't display tooltip if there is only one marker
    for (var i = 0; i < markers.length; i++) {
      createMarkerWithLocation(markers, i);
    }

    if(isSearch){
      var params = new URLSearchParams(window.location.search);
      var searchValue = params.get('search');
      search(searchValue)
    }
  }

  // Display all markers then center and zoom map around
  function createMarkerWithLocation(locations, i) {
    // create markers on map
    var position;
    if (locations[i].latlng != undefined) {
      var lat = locations[i].latlng.split(',')[0];
      var lng = locations[i].latlng.split(',')[1];
      position = {lat: parseFloat(lat), lng: parseFloat(lng)};
    }
    var icon = markerPath
    var zIndex = 0
    // GMB stores should use different color

    if (locations[i].type === 'store') {
      if (['tollens', 'www'].includes(siteaccess) && locations[i].pictos && locations[i].pictos.some(isTollensPicto) && locations[i].pictos.some(isZolpanPicto)) {
        icon = zolpanTollensMarkerPath;
      } else if (['tollens', 'www'].includes(siteaccess) && locations[i].pictos && locations[i].pictos.some(isTollensPicto)) {
        if(siteaccess == 'tollens') {
          zIndex = 1;
        }

        icon = tollensMarkerPath;
      } else if (['tollens', 'www'].includes(siteaccess) && locations[i].pictos && locations[i].pictos.some(isZolpanPicto)) {
        if(siteaccess == 'www') {
          zIndex = 1;
        }
        icon = zolpanMarkerPath;
      } else {
        icon = gmbMarkerPath;
      }
    } else {
      if (locations[i].pictos && locations[i].pictos.some(isZolpanPicto)) {
        icon = zolpanMarkerPathIdependent
      } else if (locations[i].pictos && locations[i].pictos.some(isTollensPicto)) {
        icon = tollensMarkerPathIdependent
      }
    }
    // if marker is not a store but a seach place
    if(locations[i].title == '') {
      DISPLAY_TOOLTIP = false
      icon = mainMarkerPath
      zIndex = -1
    }
    var marker = new google.maps.Marker({
      icon: icon,
      position: position,
      optimized: false,
      zIndex: zIndex,
      map: MAP,
      title: locations[i].title,
      img: locations[i].img,
      detail: locations[i].address,
      email: locations[i].email,
      storeName: locations[i].storeName,
      phone: locations[i].phone,
      url: locations[i].url,
      animation: google.maps.Animation.DROP,
      displayTooltip: locations[i].displayTooltip,
      type: locations[i].type,
      lat: lat,
      lng: lng,
      brands: locations[i].brands,
      services: locations[i].services,
      indep_custom_store_name: locations[i].indep_custom_store_name
    });
    markersList.push(marker);
    // manage centering and zoom
    bounds.extend(marker.getPosition());

    if (!mapCenter) {
      MAP.fitBounds(bounds);
    }

    // manage tooltip display
    if (DISPLAY_TOOLTIP) {
      tooltip(marker, cta);
    }
  }

  function isTollensPicto(picto) {
    if(picto.toLowerCase().trim() == 'tollens') {
      return true;
    }
    return false;
  }
  function isZolpanPicto(picto) {
    if(picto.toLowerCase().trim() == 'zolpan') {
      return true;
    }
    return false;
  }

  // Display tooltip
  function tooltip(marker, cta) {
    var storeName = marker.title;
    if(marker.type == 'independant_store') {
      if( marker.indep_custom_store_name !== '' ){
        storeName = marker.indep_custom_store_name;
      } else {
        storeName = marker.storeName;
      }
    }


    var storeMaps = marker.storeMaps;
    var lat = marker.lat;
    var long = marker.lng;

    //z for zoom in a map, t=m for maps, q for lat + lng
    var linkForStore = mapsLink + '?z=12&t=m&q=loc:' + lat +'+'+long;

    var contentHtml = '';
    var tooltipDetail = '';
    var tooltipDetailInfos = '';
    var tooltipBrandAndServices = '';
    var tooltipButton = '';

    //Tollens version
    if($(WIDGET_TOLLENS_SEL).length > 0){

      tooltipDetailInfos = '<h3 class="Map-tooltipTitle">' + storeName + '</h3>' +
      '<p>' + marker.detail + '</p>';

      
      if (marker.phone != '') {
        tooltipDetailInfos = tooltipDetailInfos + '<p>' + marker.phone + '</p>'
      }
  
      if (marker.email != '') {
        tooltipDetailInfos = tooltipDetailInfos + '<p>' + marker.email + '</p>'
      }

      if (marker.img !== '') {
        tooltipDetail = tooltipDetail + '<img class="Map-tooltipImage" src="' + marker.img + '"/>';
      }
      
      tooltipDetail = 
        tooltipDetail + 
        '<div>' +
          tooltipDetailInfos +
        '</div>'
        tooltipDetailInfos

      var contentBrands = ''
      if (marker.brands && marker.brands.length > 0) {
        contentBrands = '<div>' +
          '<strong>Marques vendues : </strong>' +
          marker.brands.map(function (brand) {
            return brand.charAt(0).toUpperCase() + brand.slice(1);
          }).join(', ') +
          '</div>';
      }

      var contentServices = ''
      if (marker.services && marker.services.length > 0 && ['tollens', 'www'].includes(siteaccess)) {
        contentServices = '<div>' +
          '<strong>Services : </strong>' +
          marker.services.map(function (service) {
            return service.charAt(0).toUpperCase() + service.slice(1);
          }).join(', ') +
          '</div>';
      }

      if (contentBrands || contentServices) {
        tooltipBrandAndServices = '<div class="Map-tooltipBrandAndServices">' + 
          (contentBrands || '') + 
          (contentServices || '') + 
        '</div>'
      }

      if (marker.type != 'independant_store') {
        tooltipButton = tooltipButton + '<a class="Map-tooltipBtn Button Button--tollensgreen js-store-tooltip-link" href="' + marker.url + '">' + cta + '</a>';
      }
      
      if (mapsLink != '') {
        var linkForStore = mapsLink + '?z=12&t=m&q=loc:' + lat +'+'+long;
        var buttonName = Translator.trans('map.maps.link');
        tooltipButton = tooltipButton + '<a class="Map-tooltipBtn Button Button--tollensgreen" href="' + linkForStore + '" target="_blank">' + buttonName + '</a>';
      }

      contentHtml = '<div class="Map-tooltipContent">' +
        '<div class="Map-tooltipDetail">' +
          tooltipDetail +
        '</div>' +
        (tooltipBrandAndServices || '') + 
        '<div class="Map-tooltipButton">' +
          tooltipButton +
        '</div>' + 
      '</div>'
    }
    else if ($(WIDGET_ZOLPAN_SEL).length > 0) {
      tooltipDetailInfos = '<h3 class="Map-tooltipTitle">' + storeName + '</h3>' +
      '<p>' + marker.detail + '</p>';

      
      if (marker.phone != '') {
        tooltipDetailInfos = tooltipDetailInfos + '<p>' + marker.phone + '</p>'
      }
  
      if (marker.email != '') {
        tooltipDetailInfos = tooltipDetailInfos + '<p>' + marker.email + '</p>'
      }

      if (marker.img !== '') {
        tooltipDetail = tooltipDetail + '<img class="Map-tooltipImage" src="' + marker.img + '"/>';
      }
      
      tooltipDetail = 
        tooltipDetail + 
        '<div>' +
          tooltipDetailInfos +
        '</div>'
        tooltipDetailInfos

      var contentBrands = ''
      if (marker.brands && marker.brands.length > 0) {
        contentBrands = '<div>' +
          '<strong>Marques vendues : </strong>' +
          marker.brands.map(function (brand) {
            return brand.charAt(0).toUpperCase() + brand.slice(1);
          }).join(', ') +
          '</div>';
      }

      var contentServices = ''
      if (marker.services && marker.services.length > 0 && ['tollens', 'www'].includes(siteaccess)) {
        contentServices = '<div>' +
          '<strong>Services : </strong>' +
          marker.services.map(function (service) {
            return service.charAt(0).toUpperCase() + service.slice(1);
          }).join(', ') +
          '</div>';
      }

      if (contentBrands || contentServices) {
        tooltipBrandAndServices = '<div class="Map-tooltipBrandAndServices">' + 
          (contentBrands || '') + 
          (contentServices || '') + 
        '</div>'
      }

      if (marker.type != 'independant_store') {
        tooltipButton = tooltipButton + '<a class="Map-tooltipBtn Button Button--green Button--plain js-store-tooltip-link" href="' + marker.url + '">' + cta + '</a>';
      }
      
      if (mapsLink != '') {
        var linkForStore = mapsLink + '?z=12&t=m&q=loc:' + lat +'+'+long;
        var buttonName = Translator.trans('map.maps.link');
        tooltipButton = tooltipButton + '<a class="Map-tooltipBtn Button Button--green Button--plain" href="' + linkForStore + '" target="_blank">' + buttonName + '</a>';
      }

      contentHtml = '<div class="Map-tooltipContent">' +
        '<div class="Map-tooltipDetail">' +
          tooltipDetail +
        '</div>' +
        (tooltipBrandAndServices || '') + 
        '<div class="Map-tooltipButton">' +
          tooltipButton +
        '</div>' + 
      '</div>'
    }
    else if ($(WIDGET_ROBBIALAC_SEL).length > 0 || $(WIDGET_PLASDOX_SEL).length > 0) {
      contentHtml = '<div class="Map-tooltipContent">' +
      '<div class="Map-tooltipDetail">';

      if( marker.img !==''){
        contentHtml = contentHtml + '<img class="Map-tooltipImage" src="' + marker.img + '"/>';
      }

      contentHtml = contentHtml + '<h3 class="Map-tooltipTitle">' + storeName + '</h3>' +
      '<p>' + marker.detail + '</p>';

      if(marker.phone != '') {
        contentHtml = contentHtml + '<p>' + marker.phone + '</p>'
      }
  
      if(marker.email != '') {
        contentHtml = contentHtml + '<p>' + marker.email + '</p>'
      }

      contentHtml += '</div><div class="Map-tooltipButton"><p>';
      if(marker.type != 'independant_store') {
        contentHtml = contentHtml + '<a class="Map-tooltipBtn Button Button--tollensgreen js-store-tooltip-link" href="' + marker.url + '">' + cta + '</a>';
      }
      if(mapsLink != '') {
        var linkForStore = mapsLink + '?z=12&t=m&q=loc:' + lat +'+'+long;
        var buttonName = Translator.trans('map.maps.link');
        var contentHtml = contentHtml + '<a class="Map-tooltipBtn Button Button--tollensgreenrevert" href="' + linkForStore + '" target="_blank">' + buttonName + '</a>';
      }
      contentHtml += '</p></div>'
    }
    //global version
    else {
      contentHtml = '<div class="Map-tooltipContent" style="width\:160px;">' +
      '<h3 class="Map-tooltipTitle">' + storeName + '</h3>' +
      '<div class="Map-tooltipDetail">' +
      '<img src="' + marker.img + '" style="width:120px;"/>' +
      '<p>' + marker.detail + '</p>';

      if(marker.phone != '') {
        contentHtml = contentHtml + '<p>' + Translator.trans('map.tooltip.phone') + ' ' + marker.phone + '</p>'
      }
  
      if(marker.email != '') {
        contentHtml = contentHtml + '<p>' + Translator.trans('map.tooltip.email') + ' ' + marker.email + '</p>'
      }
  
      if(marker.type != 'independant_store') {
        contentHtml = contentHtml + '<p><a class="Map-tooltipBtn Button Button--plain js-store-tooltip-link" href="' + marker.url + '">' + cta + '</a></p>'
      }

      if(mapsLink != '') {
        var linkForStore = mapsLink + '?z=12&t=m&q=loc:' + lat +'+'+long;
        var buttonName = Translator.trans('map.maps.link');
        var contentHtml = contentHtml + '<p><a class="Map-tooltipBtn Button Button--plain" href="' + linkForStore + '" target="_blank">' + buttonName + '</a></p>'
      }
    }

    if(marker.brands && !['tollens', 'www'].includes(siteaccess)) {
      contentHtml = contentHtml + '<div>' +
        '<div class="Map-tooltipImgs">';

      for (var b = 0; b < marker.brands.length; b++) {
        contentHtml = contentHtml +
        '<img class="Map-tooltipImg" src="/assets/themes/claessens/images/logos/'+marker.brands[b]+'.png">';
      }
      contentHtml = contentHtml +  '</div></div>';
    }

    $('.gm-style-iw').parent().addClass("Map-tooltip");

    google.maps.event.addListener(marker, 'click', function () {
      INFOWINDOW.setContent(contentHtml);
      INFOWINDOW.open(MAP, marker);
    });
  }

  // Instantiate search box
  function initializeSearchBox() {
    var input = $(WIDGET_SEARCH_SEL);
    var submit = input.next('button');
    var restrictions = $.map(input.data('map-restriction'), function (value) {
      return [value];
    });
    var options = {
      componentRestrictions: {
        country: restrictions
      }
    }
    var searchBox = new google.maps.places.Autocomplete(input[0], options);
    // Brand filtering
    var select = $(WIDGET_BRANDS_SEL);

    var reset = $(WIDGET_RESET_SEL);
    reset.on('click', function() {
      select.val('');
      input.val('');
      submit.click();
    })

    select.on('change', function() {
      search(input.val(), searchBox, select.val());
    });
    searchBox.addListener('place_changed', function() {
      search(this.getPlace().formatted_address, searchBox, select.val())
    });
    $(submit).on('click', function() {
      search(input.val(), searchBox, select.val())
    });
    $(WIDGET_GEOLOCATE).on('click', function() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function(data) {
          var geocoder = new google.maps.Geocoder();
          geocoder.geocode( {'address': data.coords.latitude +","+ data.coords.longitude}, function (results, status) {
            if (status === google.maps.GeocoderStatus.OK) {
              input.val(results[0].formatted_address);
              search(input.val(), searchBox, select.val())
            }
          });
        });
      }
    });
  }

  // Search
  // brands - array of brands - can be undefined
  function search(value, searchBox, brands) {
    mapCenter = false;
    if (value == undefined) {
      value = searchBox.getPlace().name;
    }
    if(value == "") {
      value = "all";
    }
    var url = Routing.generate('ajax_storelocator_search') + "/" + value;
    if (brands && brands.length > 0) {
      url = url + '/' + brands;
    }
    $.get({
      url: url,
      success: function (markers) {
        bounds = new google.maps.LatLngBounds();
        DISPLAY_TOOLTIP = markers.length > 1;  // don't display tooltip if there is only one marker
        for (var i = 0; i < markers.length; i++) {
          centerOnMarkerWithLocation(markers, i);
        }
      }
    });
  }

  function centerOnMarkerWithLocation(locations, i) {
    var position;
    var marker;
    if (locations[i].latlng != undefined) {
      var lat = locations[i].latlng.split(',')[0];
      var lng = locations[i].latlng.split(',')[1];
      position = {lat: parseFloat(lat), lng: parseFloat(lng)};
    }


    if (locations[i].title === '') {
      if (searchMarker) {
        searchMarker.setMap(null);
      }
      searchMarker = new google.maps.Marker({
        icon: mainMarkerPath,
        position: position,
        optimized: false,
        zIndex: -1,
        map: MAP,
      });
    } else {
      marker = new google.maps.Marker({
        position: position,
      });
    }

    bounds.extend(marker.getPosition());

    if (!mapCenter) {
      MAP.fitBounds(bounds);
    }
  }


}(jQuery));
